import { createPurseFormSchema } from '@/app/pages/providers/pages/choose_purses/choose_purses.schema'
import { PursesArray } from '@/schemas/provider.schema'
import { z } from 'zod'

export function createSendBillFormSchema(
  apiPurses: PursesArray,
  paymentAmount: number,
  allowedStudentIds: string[]
) {
  return createPurseFormSchema(apiPurses, paymentAmount).superRefine(
    (purses, ctx) => {
      const selectedPurses = purses.purses.filter((purse) => purse.isSelected)
      const hasUsedPurseOfAllSelectedStudents = allowedStudentIds.every(
        (studentId) => {
          // Find purses belonging to this student
          const studentPurses = apiPurses.filter(
            (purse) => purse.student_id.toString() === studentId
          )
          // Check if at least one of the student's purses is selected
          return studentPurses.some((studentPurse) =>
            selectedPurses.some(
              (selectedPurse) => selectedPurse.purse_id === studentPurse.id
            )
          )
        }
      )

      if (!hasUsedPurseOfAllSelectedStudents) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `All students included in the bill must have atleast one wallet selected`,
          path: ['purses'],
        })
      }
    }
  )
}
